import React from 'react';

export default class ErrorBoundary extends React.Component{
  constructor(props){ super(props); this.state={hasError:false,error:null,info:null}; }
  static getDerivedStateFromError(error){ return {hasError:true,error}; }
  componentDidCatch(error,info){ this.setState({info}); console.error("Oncer crash:",error,info); }
  render(){
    if(this.state.hasError){
      const msg=(this.state.error&&this.state.error.message)||String(this.state.error);
      return(
        <div style={{height:"100%",background:"#0A0A12",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:28,textAlign:"center",fontFamily:"Inter,sans-serif"}}>
          <div style={{fontSize:40,marginBottom:14}}>🔖💥</div>
          <div style={{fontSize:16,fontWeight:800,color:"#fff",marginBottom:10}}>Qualcosa si è rotto</div>
          <div style={{fontSize:12,color:"rgba(255,255,255,.55)",marginBottom:16,lineHeight:1.6,maxWidth:320}}>
            I tuoi dati sono al sicuro (salvati in locale). Riavvia l'app per continuare — se il problema si ripete, manda uno screenshot di questo messaggio:
          </div>
          <div style={{background:"rgba(255,255,255,.08)",borderRadius:10,padding:"10px 14px",fontSize:10,color:"#FF8FAE",fontFamily:"monospace",marginBottom:20,maxWidth:320,wordBreak:"break-word"}}>{msg}</div>
          <div onClick={()=>window.location.reload()} style={{background:"linear-gradient(135deg,#FF2D6B,#7B2FFF)",color:"#fff",padding:"13px 30px",borderRadius:40,fontSize:13,fontWeight:700,cursor:"pointer"}}>Ricarica Oncer</div>
        </div>
      );
    }
    return this.props.children;
  }
}